import cep from 'cep-promise';
import logger from '../../utils/logger';

export const getAddress = async (zipcode) => {
  return await cep(zipcode).catch((error) => {
    logger.warn('Error fetching the address\n', error);
    return { invalid: true };
  });
};
